// Module
var code = `<div id="roles-list">
  <table class="table table--last-column-to-right" ng-if="\$ctrl.roles">
    <thead>
    <tr>
      <th class="no-column-header">No</th>
      <th>Name</th>
      <th>View permissions</th>
      <th>Actions</th>
    </tr>
    </thead>
    <tbody>
    <tr ng-repeat="item in \$ctrl.roles" ng-class="{'selected': item == \$ctrl.role}">
      <td>{{\$index + 1}}.</td>

      <!-- Existing item -->
      <td ng-if="!item.dirty">
        {{item.name}}
      </td>

      <!-- New item -->
      <td ng-if="item.dirty">
        <input type="text" placeholder="Role name" required ng-model="item.name" />
        <span>Is CashierCounter:</span>
        <input type="checkbox" ng-model="item.cashierCounter" />
        <span>Is agent role:</span>
        <input type="checkbox" ng-model="item.agent" />
        <span>Is enabled:</span>
        <input type="checkbox" ng-model="item.enabled" />
      </td>

      <td>
        <button class="btn btn-info" ng-click="\$ctrl.openRole(\$index)" ng-disabled="item.dirty">Configure</button>
      </td>

      <td class="table__actions">
        <button ng-if="!item.dirty"
              class="btn btn-warning"
              ng-click="\$ctrl.editRole(\$index)">Edit</button>
        <button ng-if="!item.dirty"
                class="btn btn-danger"
                command-access="DeleteRole"
                ng-click="\$ctrl.deleteRole(\$index)">Remove</button>
        <button ng-if="item.dirty"
                class="btn btn-danger"
                ng-click="\$ctrl.cancelAddRole(\$index)">Cancel</button>
        <button ng-if="item.dirty"
                class="btn btn-success save-button"
                command-access="CreateRole"
                ng-disabled="\$ctrl.isSaveDisabled(\$index)"
                ng-click="\$ctrl.saveRole(\$index)">Save</button>
      </td>
    </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="5">
        <button class="btn btn-success pull-right" type="button" command-access="CreateRole" ng-click="\$ctrl.addRole()">
          Add new
        </button>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/roles-list/roles-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;